export const MuiInputAdornment: Partial<Record<any, any>> = {
    root: {
        width: 100,
        fontSize: ".7em"
    },   
  };